import script from "./Alert.vue?vue&type=script&setup=true&lang=js"
export * from "./Alert.vue?vue&type=script&setup=true&lang=js"

import "./Alert.vue?vue&type=style&index=0&id=043db92e&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\unensedu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-043db92e"]])

export default __exports__